export default "__VITE_ASSET__c5cd451d__"